import React from 'react'

export const SettingColors = () => {
  return (
    <div>SettingColors</div>
  )
}
